export default "__VITE_ASSET__OgxBxSyd__"